import { useEffect, useRef } from 'react'

interface UseWaitForElementToBeInDOMProps {
	selector: string
	onElementFound: (element: HTMLElement) => void
}

export const useWaitForElementToBeInDOM = ({
	selector,
	onElementFound,
}: UseWaitForElementToBeInDOMProps): void => {
	const observerRef = useRef<MutationObserver | null>(null)

	useEffect(() => {
		if (!selector) {
			return
		}

		// Check if element already exists
		const element = document.querySelector(selector)
		if (element) {
			onElementFound(element as HTMLElement)
			observerRef.current?.disconnect()
			return
		}

		// If element doesn't exist, create observer
		observerRef.current = new MutationObserver(() => {
			const element = document.querySelector(selector)
			if (element) {
				onElementFound(element as HTMLElement)
				observerRef.current?.disconnect()
			}
		})

		// Start observing
		observerRef.current.observe(document.body, {
			childList: true,
			subtree: true,
		})

		return () => {
			observerRef.current?.disconnect()
		}
	}, [selector, onElementFound])
}
